enum HopeFlag {
  ADMISSION = "admission",
  HUV1 = "huv1",
  HUV2 = "huv2",
  ADMISSION_SFV = "admissionSfv",
  HUV1_SFV = "huv1Sfv",
  HUV2_SFV = "huv2Sfv",
}

export default HopeFlag;

export interface HopeVisitSignature {
  firstName: string;
  middleName?: string;
  lastName: string;
  credentials: string[];
  sections: string[];
  sectionCompletedDate: number;
}

export interface HopeVisitSignatureDto {
  z0400signatures: HopeVisitSignature[];
}



// WEBPACK FOOTER //
// ./src/models/hope/hope-type.ts